import { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ShoppingBag, Menu, X, ArrowUpRight } from "lucide-react";
import Navbar from "./Navbar";

const NavItems = [
    { path: "/", label: "Home" },
    { path: "/products", label: "Products" },
    { path: "/category", label: "Categories" },
    { path: "/about", label: "About" },
];

export default function Header() {
    const [mobileMenu, setMobileMenu] = useState(false);

    const cart = useSelector((state) => state.cart);

    const getItemsCount = () => {
        return cart.reduce(
            (accumulator, item) => accumulator + item.quantity,
            0
        );
    };

    return (
        <>
            <header className="sticky top-0 z-50 w-full border-b border-gray-200 bg-white/95 backdrop-blur-md">

                <nav className="mx-auto flex h-20 max-w-[1600px] items-center justify-between px-6 md:px-10 lg:px-12">

                    <Link
                        to="/"
                        className="group flex items-center"
                    >
                        <span className="text-2xl font-black tracking-[-0.08em] text-gray-900">
                            LOGO
                        </span>

                        <span className="text-2xl font-black text-indigo-600">
                            .
                        </span>
                    </Link>


                    <div className="hidden items-center gap-10 md:flex">

                        {NavItems.map((item) => (
                            <Link
                                key={item.label}
                                to={item.path}
                                className="group relative py-2 text-sm font-medium text-gray-600 transition-colors duration-300 hover:text-gray-950"
                            >
                                {item.label}

                                <span className="absolute bottom-0 left-0 h-px w-0 bg-gray-950 transition-all duration-300 group-hover:w-full" />
                            </Link>
                        ))}

                    </div>


                    <div className="flex items-center gap-3">
                        <Link
                            to="/cart"
                            className="group relative flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-gray-100"
                            aria-label="Shopping cart"
                        >
                            <ShoppingBag
                                size={20}
                                strokeWidth={1.8}
                            />

                            {getItemsCount() > 0 && (
                                <span className="absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1 text-[10px] font-bold text-white">
                                    {getItemsCount()}
                                </span>
                            )}
                        </Link>


                        {/* Mobile Menu */}
                        <button
                            onClick={() => setMobileMenu((prev) => !prev)}
                            className="flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-gray-100 md:hidden"
                            aria-label="Toggle navigation"
                        >
                            {mobileMenu ? (
                                <X size={21} />
                            ) : (
                                <Menu size={21} />
                            )}
                        </button>

                    </div>

                </nav>


                
                <div className="hidden border-t border-gray-100 bg-gray-50 py-2 text-center text-xs font-medium tracking-wide text-gray-500 md:block">
                    Free shipping on orders over $100
                    <span className="ml-2 inline-flex items-center">
                        Shop now
                        <ArrowUpRight size={13} className="ml-1" />
                    </span>
                </div>

            </header>


            {/* Mobile Navigation */}
            {mobileMenu && (
                <Navbar
                    navItems={NavItems}
                    onClose={() => setMobileMenu(false)}
                />
            )}

        </>
    );
}